import { InspectionWidgets } from '@monorepo/inspections/src/components/InspectionsWidgets';
import APP from '@monorepo/old-web/js/config';
import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { Main } from '@monorepo/shared/componentsV2/Main';
import { useResetOnProjectChange } from '@monorepo/shared/hooks/navigation/useResetOnProjectChange';
import { useSearchParamState } from '@monorepo/shared/hooks/navigation/useSearchParamState';
import {
  clearSavedScrollPosition,
  getScrollPositionStorageKey,
} from '@monorepo/shared/utils/navigation/scrollPositionStorage';
import { useCurrentProject } from '@monorepo/shared/hooks/useCurrentProject';
import {
  fillHeightAndScrollable,
  page,
  verticalLayout,
} from '@monorepo/shared/styles/layout';
import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { InspectionsPageHeader } from './InspectionsPageHeader';

const StyledMain = styled(Main)`
  ${verticalLayout}
  ${page}
`;

const ScrollableContainer = styled.div`
  ${fillHeightAndScrollable}
`;

export function InspectionsPage() {
  const { project } = useCurrentProject();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const [filter, setFilter] = useSearchParamState<string>('filter');
  const nonNullFilter = filter ?? '';

  APP.projectId = project?.id; // Legacy code grabs projectId from the App object

  const setFilterCallback = useCallback(
    (value: string | null) => {
      if (project?.id) {
        clearSavedScrollPosition(
          getScrollPositionStorageKey({
            page: 'inspections',
            projectId: project.id,
          }),
        );
      }
      setFilter(value);
    },
    [project?.id, setFilter],
  );

  const clearFilter = useCallback(
    () => setFilterCallback(null),
    [setFilterCallback],
  );
  useResetOnProjectChange(project?.id, clearFilter);

  return (
    <StyledMain>
      <InspectionsPageHeader
        onSearch={setFilterCallback}
        filter={nonNullFilter}
      />
      <ErrorBoundary>
        <ScrollableContainer ref={scrollContainerRef}>
          {project ? (
            <InspectionWidgets
              filter={nonNullFilter}
              scrollContainerRef={scrollContainerRef}
            />
          ) : (
            <Loading />
          )}
        </ScrollableContainer>
      </ErrorBoundary>
    </StyledMain>
  );
}
